var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGarbage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGarbage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Save-/-delete-our-message",
    transform: "translate(-20.000000, -518.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icGarbage",
    transform: "translate(20.000000, 518.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7856086,18.3585566 L13.5675278,3.20001933 L1.61983019,3.20001933 L2.41647983,18.3578318 L2.41724244,18.378891 L2.41724244,18.3999903 C2.41724244,18.8406211 2.77551001,19.1999952 3.21469483,19.1999952 L11.9865909,19.1999952 C12.4265784,19.1999952 12.7840432,18.8406211 12.7840432,18.3999903 L12.7840432,18.378891 L12.7856086,18.3585566 Z M4.78467421,1.60000966 L4.78467421,2.4000145 L10.3668008,2.4000145 L10.3668008,1.60000966 C10.3668008,1.1586138 10.009336,0.800004832 9.56934842,0.800004832 L5.5821266,0.800004832 C5.14294178,0.800004832 4.78467421,1.1586138 4.78467421,1.60000966 Z M15.151475,2.4000145 L15.1515152,2.4000145 L15.1515152,3.20001933 L14.3657428,3.20001933 L13.5815358,18.3999903 C13.5815358,19.2835874 12.8674089,20 11.986631,20 L3.21473497,20 C2.33395707,20 1.61983019,19.2835874 1.61983019,18.3999903 L0.821615182,3.20001933 L0,3.20001933 L0,2.4000145 L3.98722182,2.4000145 L3.98722182,1.60000966 C3.98722182,0.716452888 4.7013487,0 5.5821266,0 L9.56934842,0 C10.4501263,0 11.1642532,0.716452888 11.1642532,1.60000966 L11.1642532,2.4000145 L15.151475,2.4000145 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    stroke: "#666666",
    strokeWidth: 0.3,
    points: "7.27272727 17.5757576 7.87878788 17.5757576 7.87878788 4.84848485 7.27272727 4.84848485"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "6.06060606 17.5254117 5.14010681 4.84848485 4.24242424 4.89883071 5.16296876 17.5757576"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "11.5151515 4.89797798 10.6109399 4.84848485 9.6969697 17.5262644 10.6011814 17.5757576"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGarbage);
export default __webpack_public_path__ + "static/media/icGarbage.19a82f58dd4479f8693def9e03a0f74b.svg";
export { ForwardRef as ReactComponent };